import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { YPMCOLOURVService } from './api/yPMCOLOURV.service';
import { YPMMULTICOLOURVService } from './api/yPMMULTICOLOURV.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class MultiColourApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MultiColourApiModule> {
        return {
            ngModule: MultiColourApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: MultiColourApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('MultiColourApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
